var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBenifits(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 457.7",
    style: {
      enableBackground: "new 0 0 512 457.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#5530C1;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "0,231.7 106.7,231.7 102.4,416.3 0,416.3  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M123.5,401.5l3.6-153.3l68.9,1.6c29.1,5.9,57.9,22.4,86.8,41.5l53.5,1.2c24.2,2,36.3,26.9,12.4,42.5 c-19.1,13.3-43.9,12-69.2,9.1c-17.5-1.3-18.8,22.2-0.5,22.8c6.3,0.6,13.3-0.7,19.3-0.5c31.7,0.7,57.9-4.7,74.5-29.4l8.5-18.6 l80.6-37.6c40.2-12.2,67.5,30.2,37.5,58.5c-58.7,40.6-118.6,73.8-179.8,100.3c-44.6,25.7-88.5,23.8-131.8-3.1L123.5,401.5 L123.5,401.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M182.2,109c-6.4-7.7-8.3-12.4-6.6-16.5s6.4-6,10.5-4.3l33.6,14.2c4.1,1.7,6,6.4,4.3,10.5s-6.4,6-8.2,10.3 L182.2,109z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M216.3,56.7c-3.1-3.2-3.1-8.3,0-11.4c3.2-3.1,8.3-3.1,11.4,0l25.6,25.9c3.1,3.2,3.1,8.2,0,11.4 c-3.2,3.1-8.3,3.1-11.4,0C242,82.6,216.3,56.7,216.3,56.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M267.8,21.3c-1.7-4.1,0.3-8.8,4.4-10.5s8.8,0.3,10.5,4.4l13.9,33.7c1.7,4.1-0.3,8.8-4.4,10.5l0,0 c-4.1,1.7-8.8-0.3-10.5-4.4L267.8,21.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M482.6,88.2c4.1-1.7,8.8,0.2,10.5,4.3s-0.2,8.8-4.3,16.5l-33.6,14.2c-4.1-4.3-8.8-6.2-10.5-10.3 c-1.7-4.1,0.2-8.8,4.3-10.5l0,0L482.6,88.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M443.3,45.3c3.1-3.2,8.2-3.2,11.4,0c3.1,3.1,3.2,8.2,0,11.4L429,82.6c-3.1,3.2-8.2,3.2-11.4,0 c-3.1-3.1-3.2-8.2,0-11.4L443.3,45.3L443.3,45.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M388.3,9.1C390,5,394.7,3,398.8,4.7s6.1,6.4,4.4,16.5L389.4,55c-1.7-1.9-6.4,0.1-10.5-1.6l0,0 c-4.1-1.7-6.1-6.4-4.4-10.5L388.3,9.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M326,8.1c0-4.4,3.6-8.1,8.1-8.1s8.1,3.6,8.1,8.1v36.5c0,4.5-3.6,8.1-8.1,8.1s-8.1-3.6-8.1-8.1V8.1L326,8.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M247.7,180.6c0-48.7,38.5-87.6,86-87.6c47.9,0,86.8,39.3,86.8,88s-39.3,88-87.6,88 C286.6,268.6,247.7,228.5,247.7,180.6z M355.9,165c-0.8-8.6-4.3-14.8-11.3-19.1c-1.9-1.2-3.5-1.9-4.3-4.7c-0.4-3.1-2.7-4.7-5.8-4.7 c-3.5,0-5.8,1.6-6.6,5.1c-0.4,1.9-1.6,3.1-3.5,3.9c-9.7,5.1-14.4,14.4-12.1,24.1s9.3,18.3,21.8,17.9c5.5-0.4,8.6,3.1,9,7.8 s-2.3,7.4-6.6,8.2c-4.7,1.2-7.8-1.2-9.3-5.8c-0.8-1.6-0.8-3.5-3.1-3.1c-3.9,0-7.8-0.8-11.7,0.8c0.4,9,4.7,15.2,11.7,19.5 c1.9,1.2,3.9,2.3,4.7,4.7c0.8,2.7,3.5,3.9,6.2,3.9c3.1,0,5.1-1.6,5.8-4.3c0.4-2.3,1.6-3.5,3.5-4.7c10.1-5.5,14.4-14.8,12.1-24.5 c-2.7-11.3-9.7-16.7-21.8-17.5c-2.3,0-4.3,0-6.2-1.6c-2.7-2.7-3.1-5.8-2.3-9.3c1.2-3.5,4.3-4.7,7.4-5.1c3.9-0.4,6.2,1.6,8.2,4.7 c0.8,1.9,0.4,4.7,3.9,4.7C348.5,165,352,165,355.9,165z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBenifits);
export default __webpack_public_path__ + "static/media/Benifits.b5261bc7b4616282f296bf189a0973bb.svg";
export { ForwardRef as ReactComponent };